<template>
  <div>
    <px-view-header title="Tabelas de preço" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-tabela-preco-listagem-header :on-click-refresh="onClickRefresh"
                                     :on-change-filter="onChangeFilter"
                                     @change="onChangeFilter"/>
    <px-tabela-preco-lista :tabelas-preco="tabelasPreco" :loading="loading"
                  :on-change-options="onChangeOptions"
                  :options-list="optionsList"
                  @remove="onRemove"
                  @update="onClickRefresh"/>
  </div>
</template>

<script>
import TabelaPrecoListagemHeader from '@/modules/tabela-preco/TabelaPrecoListagemHeader.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import { mapGetters } from 'vuex';
import TabelaPrecoService from '@/modules/tabela-preco/tabela-preco-service';
import TabelaPrecoLista from '@/modules/tabela-preco/TabelaPrecoLista.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      tabelasPreco: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'dataVigenciaInicial',
        sortDesc: true,
      },
      optionsList: {},
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Tabelas de preço' },
      ],
    };
  },
  computed: {
    ...mapGetters('listagemTabelasPreco', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getTabelasPreco();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getTabelasPreco();
    },
    onClickRefresh() {
      this.getTabelasPreco();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getTabelasPreco() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return TabelaPrecoService.getTabelasPreco({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.tabelasPreco = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemove(tabelaPreco) {
      this.loading = true;
      return TabelaPrecoService.remove(tabelaPreco.id)
        .then(() => {
          this.$toast('Tabela de preço removida', { color: 'success' });
          return this.getTabelasPreco();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxTabelaPrecoLista: TabelaPrecoLista,
    pxTabelaPrecoListagemHeader: TabelaPrecoListagemHeader,
  },
};
</script>
